module.exports = __webpack_public_path__ + "img/file-ruled.cd68823c.svg";